export enum StatusApproval {
	WaitingApproval = 'ST002',
	Approved = 'ST003',
	Revised = 'ST004',
	Rejected = 'ST008'
}

export enum StatusDocument {
	ApprovedDocument = 'STDV006',
	WaitingApprovalPam = 'STDV001',
	RevisedPam = 'STDV002',
	WaitingApprovalCcm = 'STDV003',
	RevisedCcm = 'STDV004',
	DraftDocument = 'STDV005',
	ApprovedPam = 'STDV007'
}

export const reviseStatuses = new Set([
	StatusDocument.RevisedPam,
	StatusDocument.RevisedCcm
]);
